import axios from 'axios';
import configurations from "../../configurations";
const publicIp = require('public-ip');

export const passwordCheck = {

    chechForNumbers: (string) => {
        var matches = string.match(/\d+/g);
        let value = matches != null ? true : false;
        return value;

    },

    checkForUpperCase: (string) => {
        var matches = string.match(/[A-Z]/);
        let value = matches != null ? true : false;
        return value;

    },

    checkForLowerCase: (string) => {
        var matches = string.match(/[a-z]/);
        let value = matches != null ? true : false;
        return value;
    },

    checkForSymbols: (string) => {
        var symbols = new RegExp(/[^A-Za-z0-9]/);
        let value = symbols.test(string) ? true : false
        return value;
    },

    checkPwdLength: (string) => {
        let value = string.length > 7 ? true : false;
        return value;
    }
}

const appendSearchParams = (queryObj, searchOrQs) => {
    if (!searchOrQs) {
        return;
    }
    const trimmed = String(searchOrQs).trim();
    if (!trimmed) {
        return;
    }
    const normalized = trimmed.startsWith("?") ? trimmed.slice(1) : trimmed;
    if (!normalized) {
        return;
    }
    try {
        const params = new URLSearchParams(normalized);
        params.forEach((value, key) => {
            queryObj[key] = value;
        });
    } catch (e) {
        /* ignore */
    }
};

/**
 * Reads query string from the current URL. Prefer window.location.search so
 * paths like /manage-prospects/?empid= still work (legacy split on /manage-prospects? did not).
 */
export const getQueryParams = () => {
    const queryObj = {};
    appendSearchParams(queryObj, window.location.search);

    const hash = window.location.hash || "";
    if (hash.includes("?")) {
        appendSearchParams(queryObj, hash.split("?").slice(1).join("?"));
    }

    const href = window.location.href || "";
    if (!Object.keys(queryObj).length && href.includes("login?")) {
        const afterLogin = href.split("login?")[1];
        const beforeHash = (afterLogin || "").split("#")[0];
        appendSearchParams(queryObj, beforeHash);
    }

    if (!queryObj.empid && href.includes("manage-prospects")) {
        const idx = href.indexOf("manage-prospects");
        const tail = href.slice(idx + "manage-prospects".length);
        const q = tail.indexOf("?");
        if (q >= 0) {
            appendSearchParams(queryObj, tail.slice(q));
        }
    }

    return queryObj;
}

/**
 * Employer-scoped APIs need a non-empty empid path segment. Resolves from (in order):
 * explicit argument, current URL query, session from login, then USER_DATA written at login.
 */
export const getResolvedEmployerEmpid = (preferredEmpid) => {
    const clean = (v) => {
        if (v == null) {
            return "";
        }
        const s = String(v).trim();
        if (!s || s === "null" || s === "undefined") {
            return "";
        }
        return s;
    };
    let id = clean(preferredEmpid);
    if (id) {
        return id;
    }
    try {
        id = clean(getQueryParams().empid);
        if (id) {
            return id;
        }
    } catch (e) {
        /* ignore */
    }
    id = clean(localStorage.getItem("loggedInEmpId"));
    if (id) {
        return id;
    }
    try {
        const raw = sessionStorage.getItem("USER_DATA");
        if (!raw) {
            return "";
        }
        const u = JSON.parse(raw);
        id = clean(u && (u.employerEmpid != null ? u.employerEmpid : u.empid));
        if (id) {
            return id;
        }
    } catch (e) {
        /* ignore */
    }
    return "";
};

/**
 * empid for employer-scoped APIs (counts, employer profile). Uses explicit id when present
 * (e.g. ?empid= from URL or agent drilling into an employer). If missing, only falls back to
 * session/USER_DATA on the Employer portal so Agent portal never picks up a stray loggedInEmpId.
 */
export const getEmployerScopedEmpidForApi = (explicitEmpid) => {
    const raw =
        explicitEmpid != null && explicitEmpid !== ""
            ? String(explicitEmpid).trim()
            : "";
    if (raw && raw !== "null" && raw !== "undefined") {
        return getResolvedEmployerEmpid(raw);
    }
    if (process.env.REACT_APP_PORTAL === "employer") {
        return getResolvedEmployerEmpid();
    }
    return "";
};

/**
 * True when member totals should use employer scope: employer portal login, or
 * agent portal with a specific employer open (empid). "Work with Employers" alone
 * uses agent scope until an employer is opened.
 */
export const shouldUseEmployerMemberTotalsScope = (explicitEmployerId) => {
    if (process.env.REACT_APP_PORTAL === "employer") {
        return true;
    }
    return Boolean(getEmployerScopedEmpidForApi(explicitEmployerId));
};

/**
 * GET /enrollment/getTotalOfMemberByAgentId/{agentId}
 * - Normal agent flow: ?type=agent
 * - Employer-scoped views: ?type=employer&employerId={empid} when empid is known
 */
export const buildGetTotalOfMemberByAgentIdUrl = (agentId, explicitEmployerId) => {
    const trimmedAgentId = agentId != null ? String(agentId).trim() : "";
    if (!trimmedAgentId) {
        return "";
    }
    const base = process.env.REACT_APP_BASE_URL || "";
    const path = `/enrollment/getTotalOfMemberByAgentId/${encodeURIComponent(trimmedAgentId)}`;
    const params = new URLSearchParams();

    if (shouldUseEmployerMemberTotalsScope(explicitEmployerId)) {
        params.set("type", "employer");
        const employerId = getEmployerScopedEmpidForApi(explicitEmployerId);
        if (employerId) {
            params.set("employerId", employerId);
        }
    } else {
        params.set("type", "agent");
    }

    return `${base}${path}?${params.toString()}`;
};

/**
 * Setup ACH payload for add/update employer.
 * - All fields empty -> returns null (so caller sends employerPayment: null)
 * - Any field filled  -> returns object with filled values; missing ones as null
 */
export const buildEmployerPaymentPayload = (fields = {}) => {
    const keys = ["bankName", "accountName", "accountNumber", "accountType", "routingNo"];
    const cleaned = {};
    let hasAny = false;
    keys.forEach((key) => {
        const raw = fields[key];
        const value = raw == null ? "" : String(raw).trim();
        if (value !== "") {
            cleaned[key] = value;
            hasAny = true;
        } else {
            cleaned[key] = null;
        }
    });
    return hasAny ? cleaned : null;
};

export const getPublicIP = async () => {
    let ipv4 = await publicIp.v4();
    sessionStorage.setItem('PUBLIC-IP', ipv4);
}

export const getBrowser = () => {
    //const currDate = "Current Date= "+date;
    var browser;
    if (navigator.userAgent.indexOf("Chrome") != -1) {
        browser = "Google Chrome";
    }
    // FIREFOX
    else if (navigator.userAgent.indexOf("Firefox") != -1) {
        browser = "Mozilla Firefox";
    }
    // INTERNET EXPLORER
    else if (navigator.userAgent.indexOf("MSIE") != -1) {
        browser = "Internet Exploder";
    }
    // EDGE
    else if (navigator.userAgent.indexOf("Edge") != -1) {
        browser = "Internet Exploder";
    }
    // SAFARI
    else if (navigator.userAgent.indexOf("Safari") != -1) {
        browser = "Safari";
    }
    // OPERA
    else if (navigator.userAgent.indexOf("Opera") != -1) {
        browser = "Opera";
    }
    // YANDEX BROWSER
    else if (navigator.userAgent.indexOf("Opera") != -1) {
        browser = "YaBrowser";
    }
    // OTHERS
    else {
        browser = "Others";
    }
    return browser
}
export const getDeviceType = () => {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        // some code..
        return "mobile";
    }
    else {
        return "computer";
    }
}

export const getOs = () => {
    var userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
    }
    return (os);

}

export const getDateTime = () => {
    var tempDate = new Date();
    var year = tempDate.getFullYear();
    var month = "" + (tempDate.getMonth() + 1);
    var day = "" + tempDate.getDate();
    var hour = "" + tempDate.getHours();
    var minute = "" + tempDate.getMinutes();
    var seconds = "" + tempDate.getSeconds();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    if (hour.length < 2)
        hour = '0' + hour;
    if (minute.length < 2)
        minute = '0' + minute;
    if (seconds.length < 2)
        seconds = '0' + seconds;
    let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var dateTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + seconds;
    return ({ dateTime: dateTime, timeZone: timeZone });
}

export const saveLogin = (email) => {
    let os = getOs();
    let device = getDeviceType();
    let browser = getBrowser();
    let time = getDateTime();

    console.log('===================== login Details ==========================');

    let obj = {
        email: email,
        ipAddress: sessionStorage.getItem('PUBLIC-IP'),
        os: os,
        device: device,
        browser: browser,
        timestamp: time.dateTime,
        timezone: time.timeZone,
    }
    console.log(obj);

    sessionStorage.setItem('LOGIN_SAVED', 'true')
    sessionStorage.setItem('empEmail', email)
    /*axios.post(configurations.baseUrl + '/agent/saveLoginDetails', obj)
        .then(response =>{
        })*/
}

export const getTokenForAuthentication = () => {
    let request = {
        "username": process.env.REACT_APP_AUTH_USERNAME,
        "password": process.env.REACT_APP_AUTH_TOKEN_PASS
    }
    if (process.env.REACT_APP_BUILD == 'prod') {
        request.password = "x1TXVUtXL6PaBWam"
    }
    // axios expects a config object as 3rd param; passing boolean breaks request building
    return axios.post(process.env.REACT_APP_csr_base_url + "login", request)
    // let token = response['headers'].authorization || '';

    // return 'sdf'
}